<!-- INFO Y BUSCAR -->
<div class="row">
  <div class="col-12 btnSentStatus" style="text-align: center">
    <div style="padding-bottom: 20px">
      <a *ngIf="!expedition || expedition.ProductType === 'B2C'" [routerLink]="HomeRoute" title="" class=""><i
          class="bi bi-arrow-left" (click)="clickBack()"></i></a>&nbsp;&nbsp;
      <a *ngIf="expedition?.ProductType === 'B2B'"
        href="https://www.dhl.com/es-es/parcel/home/business-to-business-shipments.html" title="" class=""><i
          class="bi bi-arrow-left" (click)="clickBack()"></i></a>&nbsp;&nbsp;
      <span><b>{{ "Shared.ShipmentNumberSearch" | translate }}</b> </span><span>&nbsp;{{
        expedition ? expedition.ExpeditionNumber : expeditionNumber
        }} </span>&nbsp;&nbsp;<br class="mobile" />
      <!-- <span><b>{{'Shared.ZipCodeSearch' | translate}}</b> <span>{{expedition?.ZipCode}}</span></span>&nbsp;&nbsp; -->
      <a [focus] *ngIf="expedition" style="color: #d40511; text-align: center" (click)="clickDetalle()">
        <span *ngIf="collapseDetailShipping" class="icono_collapsed">
          <i class="bi bi-plus-lg"></i>
        </span>
        <span *ngIf="!collapseDetailShipping" class="icono_uncollapsed">
          <i class="bi bi-dash-lg"></i>
        </span>
        {{ "Shared.Details" | translate }}
      </a>
      <ng-container *ngIf="expedition">
        &nbsp;&nbsp;
        <span><b>{{ "Shared.Items" | translate }}:&nbsp;</b> </span><a style="color: #d40511; text-align: center"
          (click)="toggleCollapsePackages()">
          <span *ngIf="collapsePackage" class="icono_collapsed">
            <i class="bi bi-plus-lg"></i>
          </span>
          <span *ngIf="!collapsePackage" class="icono_uncollapsed">
            <i class="bi bi-dash-lg"></i>
          </span>
          {{ expedition?.ItemsNumber }}
        </a>
      </ng-container>
    </div>
    <div [collapse]="contracted">
      <div class="well" style="padding-bottom: 0; border: none; background: #f0efea">
        <form class="form-group" style="margin-bottom: 0" autocomplete="on" id="busqueda"
          (ngSubmit)="searchExpedition()">
          <div class="row" style="place-content: center">
            <div class="col-12 offset-md-3 col-md-4">
              <input name="expeditionNumber" [(ngModel)]="expeditionNumber" [regexReplace]="regexExpedition" type="text"
                class="form-control" placeholder="{{ 'Shared.ShipmentNumberInput' | translate }}"
                style="background: #fff" maxlength="39" />
            </div>
            <div class="col-12 col-md-2 btnStatusOptions btnLocalizar" style="margin-top: 0; padding-bottom: 0">
              <button id="search" class="btn btn-default">
                {{ "Shared.Search" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="expedition?.ItemsNumber" [collapse]="collapseDetailShipping">
      <div class="well" style="
          border: none;
          background: #f0efea;
          text-align: left;
          padding: 0 15px;
          margin-bottom: 15px;
        ">
        <div class="row">
          <table class="table-responsive table" style="margin-bottom: 0">
            <tbody class="tablaDetalles">
              <tr>
                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.ShipmentNumber" | translate }}:&nbsp;</b>
                  <br class="mobile" />{{ number }}
                </th>

                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.Origin" | translate }}:</b>
                  <br class="mobile" />&nbsp;{{ expedition?.Origin }}
                </th>

                <th style="width: 12%; border: none; font-weight: normal">
                  <b>{{ "Shared.Items" | translate }}:</b>
                  {{ expedition?.ItemsNumber }}
                </th>

                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.InternationalReference" | translate }}:&nbsp;</b>
                  <br class="mobile" />{{ expedition?.InternationalNumber }}
                </th>
              </tr>
              <tr>
                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.Product" | translate }}:&nbsp;</b>
                  <br class="mobile" />{{ expedition?.Product }}
                </th>

                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.Destination" | translate }}:</b>
                  <br class="mobile" />&nbsp;{{ expedition?.Destination }}
                </th>

                <th style="width: 12%; border: none; font-weight: normal">
                  <b>{{ "Shared.Kilos" | translate }}:</b>
                  {{ expedition?.Weight }}
                </th>

                <th style="width: 29%; border: none; font-weight: normal">
                  <b>{{ "Shared.ShipperReference" | translate }}:&nbsp;</b>
                  <br class="mobile" />{{ expedition?.CustomerReference }}
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="expedition?.ItemsNumber" [collapse]="collapsePackage">
      <div class="well bultos" style="border: none; background: #f0efea; text-align: left">
        <table class="table panelTracking" style="margin: 0 auto">
          <thead>
            <tr>
              <th class="infoSeguimientoReferencia" style="width: 26%; padding-right: 5px">
                {{ "Shared.ItemReference" | translate }}
              </th>
              <th class="infoSeguimientoFecha" style="width: 12%; text-align: left; padding-left: 15px">
                {{ "Shared.Date" | translate }}
              </th>
              <th class="infoSeguimientoHora" style="width: 6%; text-align: left">
                {{ "Shared.Time" | translate }}
              </th>
              <th class="infoSeguimiento" style="width: 26%; text-align: left">
                {{ "Shared.Status" | translate }}
              </th>
              <th class="infoSeguimientoCiudad" style="width: 22%; text-align: left">
                {{ "Shared.Town" | translate }}
              </th>
              <th class="infoSeguimientoBtn" style="width: 6%; text-align: right">
                {{ "Shared.Details" | translate }}
              </th>
            </tr>
          </thead>

          <tbody style="position: relative">
            <ng-scrollbar #scrollbarRef track="all" [disabled]="false" [autoHeightDisabled]="false"
              class="listServicepoints" style="position: relative">
              <tr *ngFor="let info of detailPackages; let i = index" class="table-row">
                <td class="infoSeguimientoReferencia2" style="width: 26%; padding-right: 5px">
                  <a (click)="showDetailPackage(info)">{{
                    info.LicensePlate
                    }}</a>
                </td>
                <td class="infoSeguimientoFecha" style="width: 12%; text-align: left; padding-left: 15px">
                  {{ info.Date }}
                </td>
                <td class="infoSeguimientoHora" style="width: 6%; text-align: left">
                  {{ info.Time }}
                </td>
                <td class="infoSeguimiento" style="width: 26%; text-align: left">
                  {{ info.Status }}
                </td>
                <td class="infoSeguimientoCiudad" style="width: 22%; text-align: left">
                  {{ info.Town }}
                </td>
                <td class="infoSeguimiento infoSeguimientoBtn" style="width: 47px; text-align: right">
                  <a style="float: end" (click)="showDetailPackage(info)"><i
                      class="row iconMasInfo bi bi-plus-lg"></i></a>
                </td>
              </tr>
            </ng-scrollbar>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>